import script from "./pc-module-task-percent-4.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-task-percent-4.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-task-percent-4.vue?vue&type=style&index=0&id=3695fa72&lang=scss"

const __exports__ = script;

export default __exports__